import React, { Component } from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import Desc from './Desc';
import ReferralLinkBlock from './ReferralLinkBlock';
import ReferralTotalInfoBlock from './ReferralTotalInfoBlock';
import ReferralsList from './ReferralsList';
import UserReferralsDayStat from './UserReferralsDayStat';

class ReferralMyStat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupQueryParams: qs.parse(this.props.location.search.slice(1))
    };
  }

  setGroupQueryParamsAndUpdateHistory = queryParams => {
    this.state.groupQueryParams = {
      ...this.state.groupQueryParams,
      ...queryParams
    };
    this.context.router.history.push({
      pathname: this.props.location.pathname,
      search: `?${qs.stringify(this.state.groupQueryParams)}`
    });
  };

  render() {
    return (
      <React.Fragment>
        <Desc />
        <ReferralLinkBlock />
        <ReferralTotalInfoBlock />
        <ReferralsList
          blockName={'referralsList'}
          initQueryParams={_.get(this.state.groupQueryParams, 'referralsList')}
          setGroupQueryParamsAndUpdateHistory={
            this.setGroupQueryParamsAndUpdateHistory
          }
        />
        <UserReferralsDayStat
          blockName={'userDaysStatTable'}
          initQueryParams={_.get(
            this.state.groupQueryParams,
            'userDaysStatTable'
          )}
          setGroupQueryParamsAndUpdateHistory={
            this.setGroupQueryParamsAndUpdateHistory
          }
        />
      </React.Fragment>
    );
  }
}

ReferralMyStat.contextTypes = {
  router: PropTypes.shape()
};

ReferralMyStat.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(ReferralMyStat);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/ReferralMyStat.js